export const DragTypes = {
  SECTION: 'section',
  ELEMENT: 'element',
  ITEM: 'item',
}
